import { CCol } from "@coreui/react"
import { getAvantraUrl } from "api/collections/avantra"
import AvantraLogo from "assets/icons/Avantra-vector.svg"
import AvantraText from "assets/icons/AVANTRA.svg"
import DDLogo from "assets/icons/dd_logo_v_rgb.svg"
import { datadogTooltip } from "constants/StringConstants"
import React from "react"
import { useSelector } from "react-redux"
import useSWR from "swr"
import { useExtension, useUserAuth } from "utils"

import CMSCard from "../cards/CMSCards"
import { withErrorBoundary } from "../error"
import { Tooltip } from "../tooltip"

/**
 * For rendering "Datadog" & "Avantra" card
 */
export default withErrorBoundary(function () {
  const auth = useUserAuth()
  const extension = useExtension()

  const host = extension?.config?.env?.clientApiGateway?.URL

  const projectID = useSelector((state) => {
    return state.settings.currentProject
  })

  const { data: avantraUrlData } = useSWR(
    () => (projectID ? `/avantra/${projectID}/get_avantra_url` : null),
    () => getAvantraUrl({ auth, host }, projectID),
    { revalidateOnFocus: false, suspense: true }
  )

  const avantraCardData = () => {
    return (
      <Tooltip
        text={datadogTooltip}
        className="mr-3"
        containerClass="bg-white"
        zIndex={1000}
        disabled={
          !(
            Array.isArray(avantraUrlData?.data) &&
            avantraUrlData.data[0]?.okta_url
          )
        }
      >
        <CCol>
          <img src={AvantraLogo} alt={"Avantra Logo"} className="icon-class" />
        </CCol>

        <CCol>
          <img
            src={AvantraText}
            alt={"Avantra Text"}
            className="textIcon-class"
          />
        </CCol>
      </Tooltip>
    )
  }
  return (
    <>
      <CMSCard
        clickable
        disabled={
          Array.isArray(avantraUrlData?.data) &&
          avantraUrlData.data[0]?.okta_url
        }
        href={"https://app.datadoghq.com/account/login?redirect=f"}
      >
        <div className="cms-button-card d-flex align-items-center justify-content-center">
          <img src={DDLogo} alt={"Datadog Logo"} className="icon2-class" />
        </div>
      </CMSCard>
      <CMSCard
        clickable
        disabled={
          !(
            Array.isArray(avantraUrlData?.data) &&
            avantraUrlData.data[0]?.okta_url
          )
        }
        href={
          Array.isArray(avantraUrlData?.data)
            ? avantraUrlData?.data[0]?.okta_url
            : ""
        }
      >
        <div className="cms-button-card d-flex align-items-center justify-content-center">
          {avantraCardData()}
        </div>
      </CMSCard>
    </>
  )
})
